module.exports = __webpack_public_path__ + "img/vn_qrcode_zalo.5ac53ae.webp";